import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-view-signer',
    templateUrl: './view-signer.component.html',
    styleUrls: ['./view-signer.component.css'],
    standalone: false
})
export class ViewSignerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
